import {CanActivateFn, Router} from "@angular/router";
import {inject} from "@angular/core";
import {TeacherService} from "./services/teacher.service";

/** Guard routes based on the user's role */
export const roleGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const teacherService = inject(TeacherService);

  const teacher = await teacherService.getTeacher();

  const allowedRoles: string[] = route.data['allowedRoles'] || [];
  const role = teacher?.role?.toLowerCase() || '';

  if (allowedRoles.map(r => r.toLowerCase()).includes(role)) {
    return true;
  } else {
    router.navigate(['/home']);
    return false;
  }
}

